var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableDashAdmOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0H5C2.243 0 0 2.243 0 5V15C0 17.757 2.243 20 5 20H19C21.757 20 24 17.757 24 15V5C24 2.243 21.757 0 19 0ZM5 2H19C20.654 2 22 3.346 22 5H2C2 3.346 3.346 2 5 2ZM2 15V7H7V18H5C3.346 18 2 16.654 2 15ZM19 18H9V7H22V15C22 16.654 20.654 18 19 18Z",
    fill: "#062F67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableDashAdmOff);
export default __webpack_public_path__ + "static/media/tableDashAdmOff.a6b4b9fdaef39fdc632c63b9dd3b8390.svg";
export { ForwardRef as ReactComponent };